<template>
  <modal
    :id="modalId"
    :visible="true"
    :title="capitalizeTranslation('messages.myViews')"
    :button1-caption="capitalize($t('actions.close'))"
    :button2-visible="false"
    :use-full-width="true"
    @confirmed="onClose"
    @cancelled="onClose"
    @button1-clicked="onClose">
    <template #modal-after-form>
      <view-list
        :available-filters="availableFilters"
        :table-settings="tableSettings"
        @apply-view="applyView"
        @closed="onClose" />
    </template>
  </modal>
</template>

<script lang="ts" setup>
  import { capitalize } from 'vue';

  import Modal from '@/common/components/controls/Modal.vue';
  import { ITableFilter } from '@/common/components/controls/table/TableFilter';
  import TableSettings from '@/common/components/controls/table/TableUserSettings/TableSettings';
  import UserView from '@/common/components/controls/table/TableUserSettings/UserView';
  import { capitalizeTranslation } from '@/globals';

  import ViewList from './ViewList.vue';

  interface IProps {
    availableFilters: ITableFilter[];
    tableSettings: TableSettings;
  }

  const { availableFilters, tableSettings } = defineProps<IProps>();

  const modalId = 'user-views-list-modal';

  const emits = defineEmits(['applyView', 'close']);

  function onClose() {
    emits('close');
  }

  function applyView(filters: UserView) {
    emits('applyView', filters);
  }
</script>
